import Script from 'next/script'

export function InitWindowDataLayerScript() {
    return (
        <Script id="init-window-data-layer" strategy="beforeInteractive" type="text/javascript">
            {`
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
            `}
        </Script>
    )
}
